import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const GearWarningIcon = createIcon({
  displayName: 'GearWarningIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M12.00107,11.72475V9.0005"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.815,13.79636l.04889-.01222A1.5,1.5,0,0,0,21,12.32892v-.65819a1.5,1.5,0,0,0-1.13615-1.45522l-.049-.01226a1.657,1.657,0,0,1-1.01809-2.45989l.02059-.03432a1.50258,1.50258,0,0,0-.22079-1.84042l-.46541-.46542a1.5,1.5,0,0,0-1.83238-.22561l-.04332.026A1.65639,1.65639,0,0,1,13.79635,4.185l-.01222-.04887A1.5,1.5,0,0,0,12.32891,3h-.6582a1.5,1.5,0,0,0-1.45522,1.13615l-.01226.049A1.657,1.657,0,0,1,7.74334,5.20327L7.709,5.18268a1.50256,1.50256,0,0,0-1.84041.22078l-.46541.46541a1.4998,1.4998,0,0,0-.2257,1.83223l.02561.0427A1.657,1.657,0,0,1,4.185,10.20371l-.04884.01222A1.5,1.5,0,0,0,3,11.67108l0,.65829a1.49955,1.49955,0,0,0,1.13579,1.455l.04852.01214a1.657,1.657,0,0,1,1.01952,2.45931L5.1779,16.299a1.5,1.5,0,0,0,.22556,1.83233l.46546.46549a1.49952,1.49952,0,0,0,1.83194.22574l.04289-.02574a1.657,1.657,0,0,1,2.45993,1.01807l.01223.0489A1.5,1.5,0,0,0,11.67106,21l.65828,0a1.49964,1.49964,0,0,0,1.455-1.13586l.01213-.0485a1.65692,1.65692,0,0,1,2.45929-1.01947l.04323.02593a1.5,1.5,0,0,0,1.83233-.22557l.4655-.46547a1.49955,1.49955,0,0,0,.22572-1.83194l-.02572-.04288A1.657,1.657,0,0,1,19.815,13.79636Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.99893,14.73064a.13256.13256,0,0,0-.13279.13493.13574.13574,0,0,0,.13493.13493.13494.13494,0,0,0-.00214-.26986"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
    </>
  ),
})

const GearWarning: FC<IconProps> = (props) => {
  return <CustomIcon as={GearWarningIcon} {...props} />
}

export default memo(GearWarning)
